import { useEffect, useMemo, useState } from 'react'
import { useDonation } from '../context/DonationContext'

export default function FilterSection() {
  const { 
    state: { filterStartDate, filterEndDate, filterCountry, masterDonations },
    setFilterStartDate,
    setFilterEndDate,
    setFilterCountry,
    filterDonations
  } = useDonation()

  // Add client-side rendering check
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  // Get unique countries from masterDonations
  const uniqueCountries = useMemo(() => {
    return Array.from(new Set(
      masterDonations
        .map(d => d.Country || '')
        .filter(Boolean)
    )).sort()
  }, [masterDonations])

  useEffect(() => {
    filterDonations()
  }, [filterDonations])

  return (
    <div id="filterSection" className="mb-6">
      <div className="flex justify-end items-center gap-2">
        <label htmlFor="startDate" className="text-gray-600">Start Date:</label>
        <input 
          type="date" 
          id="startDate" 
          value={new Date(filterStartDate.getTime() - filterStartDate.getTimezoneOffset() * 60000)
            .toISOString()
            .split('T')[0]}
          onChange={(e) => {
            const [year, month, day] = e.target.value.split('-').map(Number)
            const date = new Date(year, month - 1, day, 0, 0, 0, 0)
            setFilterStartDate(date)
          }}
          className="border rounded px-2 py-1" 
        />
        
        <label htmlFor="endDate" className="text-gray-600">End Date:</label>
        <input 
          type="date" 
          id="endDate" 
          value={new Date(filterEndDate.getTime() - filterEndDate.getTimezoneOffset() * 60000)
            .toISOString()
            .split('T')[0]}
          onChange={(e) => {
            const [year, month, day] = e.target.value.split('-').map(Number)
            const date = new Date(year, month - 1, day, 23, 59, 59, 999)
            setFilterEndDate(date)
          }}
          className="border rounded px-2 py-1" 
        />

        <label htmlFor="country" className="text-gray-600">Country:</label>
        <select
          id="country"
          value={filterCountry}
          onChange={(e) => setFilterCountry(e.target.value)}
          className="border rounded px-2 py-1 min-w-[150px]"
        >
          <option value="">All Countries</option>
          {isClient && uniqueCountries.map(country => (
            <option key={country} value={country}>{country}</option>
          ))}
        </select>

        <button 
          onClick={filterDonations} 
          className="bg-primary hover:bg-primary/80 text-white font-bold py-2 px-4 rounded"
        >
          Apply Filter
        </button>
      </div>
    </div>
  )
}

